import { createStore } from 'vuex'
import general from './modules/general'
import users from './modules/users'
import studies from './modules/studies'
import statistics from './modules/statistics'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  modules: {
    general,
    users,
    studies,
    statistics
  },
  strict: debug
})
